const STORAGE_PREFIX = 'table-column-config:'

export function buildDefaultColumnConfig (definitions) {
  return definitions.map(col => ({
    key: col.key,
    visible: col.defaultVisible !== false,
  }))
}

export function normalizeColumnConfig (definitions, savedConfig) {
  const definitionMap = _.keyBy(definitions, 'key')

  if (!savedConfig || !Array.isArray(savedConfig.columns)) {
    return buildDefaultColumnConfig(definitions)
  }

  const savedKeys = new Set()
  const result = []

  savedConfig.columns.forEach(item => {
    const definition = definitionMap[item.key]
    if (!definition) {
      return
    }
    savedKeys.add(item.key)
    result.push({
      key: item.key,
      visible: definition.locked ? true : item.visible !== false,
    })
  })

  definitions.forEach(col => {
    if (!savedKeys.has(col.key)) {
      result.push({
        key: col.key,
        visible: col.defaultVisible !== false,
      })
    }
  })

  return result
}

export function resolveVisibleColumns (definitions, config) {
  const definitionMap = _.keyBy(definitions, 'key')

  return config
    .filter(item => item.visible && definitionMap[item.key])
    .map(item => definitionMap[item.key])
}

export function loadColumnConfig (storageKey) {
  if (!storageKey) {
    return null
  }
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${storageKey}`)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function saveColumnConfig (storageKey, config) {
  if (!storageKey) {
    return
  }
  localStorage.setItem(`${STORAGE_PREFIX}${storageKey}`, JSON.stringify(config))
}



// WEBPACK FOOTER //
// ./core/utils/table-column-config.js